import { render, staticRenderFns } from "./PillsSelectSingle.vue?vue&type=template&id=619564ba"
import script from "./PillsSelectSingle.vue?vue&type=script&lang=ts"
export * from "./PillsSelectSingle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports